import { DisconnectOutlined } from '@ant-design/icons';
import { useMutation } from '@tanstack/react-query';
import {
    Button, theme,
} from 'antd';
import {
    CSSProperties, useCallback,
} from 'react';
import { useNavigate } from 'react-router-dom';

import { authMutations } from '@/api';
import { AppRoute } from '@/constants';
import { useUserStore } from '@/stores';

const linkStyle: CSSProperties = {
    color: theme.getDesignToken().colorTextLightSolid,
};

type LogoutProps = {
    /** false — для світлого фону (наприклад Drawer) */
    useSolidHeaderStyle?: boolean;
};

export const Logout = ({ useSolidHeaderStyle = true }: LogoutProps) => {
    const navigate = useNavigate();

    const { mutate: logout } = useMutation({
        ...authMutations.logout(),
        onSuccess: () => {
            useUserStore.getState().setUser(null);
            navigate(AppRoute.Login);
        },
    });

    const handleLogout = useCallback(() => {
        logout();
    }, [logout]);

    return (
        <Button
            type="link"
            icon={<DisconnectOutlined />}
            style={useSolidHeaderStyle ? linkStyle : undefined}
            onClick={handleLogout}
        >
            Вихід із системи
        </Button>
    );
};
